import { Navigate, Outlet, useParams } from "react-router-dom";
import { t } from "@lingui/core/macro";
import WithSideNaviWrapper from "../router/with-side-navi-wrapper";
import { groupTabViews } from "./tabs/view/info-view";
import { useInternalCompaniesQuery } from "../queries/internal-companies.queries";
import { Company } from "../dtos/company.model";
import { hasPermission } from "../helper";
import { useMeQuery } from "../queries/me.queries";
import { Permission } from "../constant";
import { featureFlags } from "../feature-flag/feature-flag.utils";

const UserGroupLayout = () => {
  const { companyId } = useParams();
  const { data: companies = [] } = useInternalCompaniesQuery();
  const { data: currentUser } = useMeQuery();

  const getTabList = () => {
    const values = groupTabViews();
    const company = companies.find((company) => company.id === +companyId);
    const isCustomer = company && !new Company(company).isCompany();

    if (
      (hasPermission(
        currentUser?.permissions,
        Permission.ADMIN_ALARM_SETTINGS_VIEW,
      ) ||
        hasPermission(
          currentUser?.permissions,
          Permission.ADMIN_ALARM_SETTINGS_EDIT,
        )) &&
      featureFlags.isFeatureEnabled("Alarm Notification Configuration")
    ) {
      values.navList.push({
        id: "alarm-notification-configuration",
        label: t`Alarm settings`,
      });
    }

    if (isCustomer) {
      return values;
    }
    // show customer tabs in user group only for company section.
    values.navList.push({ id: "customers", label: t`Customers` });

    return values;
  };

  return <WithSideNaviWrapper component={Outlet} navInfo={getTabList} />;
};

export const COMPANY_USER_GROUPS_ROUTES = [
  { index: true, element: <Navigate to="active" replace /> },
  {
    path: "active",
    lazy: () => import("./group-list"),
  },
  {
    path: "deactive",
    lazy: () => import("./group-list"),
  },
  {
    path: "new",
    lazy: () => import("./tabs/create"),
  },
  {
    path: ":groupId/*",
    element: <UserGroupLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="info" replace />,
      },
      {
        path: "info",
        lazy: () => import("./tabs/view/info-view"),
      },
      {
        path: "roles",
        lazy: () => import("./tabs/view/roles-view"),
      },
      {
        path: "users",
        lazy: () => import("./tabs/view/users-view"),
      },
      {
        path: "device-rights",
        lazy: () => import("./tabs/view/device-rights-view"),
      },
      {
        path: "alarm-notification-configuration",
        lazy: () => import("./tabs/view/alarm-notification-configuration-view"),
      },
      {
        path: "customers",
        lazy: () => import("./tabs/view/customers-view"),
      },
    ],
  },
  {
    path: ":groupId/edit/*",
    element: <WithSideNaviWrapper component={Outlet} />,
    children: [
      {
        path: "info",
        lazy: async () => import("./tabs/edit/info-edit"),
      },
      {
        path: "roles",
        lazy: async () => import("./tabs/edit/roles-edit"),
      },
      {
        path: "users",
        lazy: async () => import("./tabs/edit/users-edit"),
      },
      {
        path: "device-rights",
        lazy: () => import("./tabs/edit/device-rights-edit"),
      },
      {
        path: "alarm-notification-configuration",
        lazy: () => import("./tabs/edit/alarm-notification-configuration-edit"),
      },
      {
        path: "customers",
        lazy: () => import("./tabs/edit/customers-edit"),
      },
      {
        path: "copy",
        lazy: () => import("./tabs/edit/copy-group"),
      },
    ],
  },
];
